import React, { Component } from 'react'
import { connect } from 'react-redux'
import ImmunizationSideInfo from './immunizationSideInfo'

class ImmunizationsLowerInfo extends Component {
    render() {
        return (
        <div>
            <div className="d-inline d-md-none">
                <ImmunizationSideInfo  />
            </div>
            <div className="py-3">
                <div className="alert my-0">
                    <b>
                        {this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_1}
                        {this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_2}
                        <a href={this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_LINK} target="_blank">
                            <i>{this.props.strings.IMMUNIZATIONS_BOTTOM_ALERT_3}</i>
                        </a>
                    </b>
                </div>
            </div>
        </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        language: state.language.language,
    }
}

const ConnectedImmunizationsLowerInfo = connect(
    mapStateToProps
)(ImmunizationsLowerInfo);
export default ConnectedImmunizationsLowerInfo;
